import type { CalendarSource } from '../../hooks/useCalendarApi';

/**
 * Цвет источника — это информация, а не украшение: по нему на месяц вперёд
 * видно, что впереди густо от ревью, а не от эссе. Просроченное красит себя
 * красным поверх источника, поэтому красный тут не занят.
 */
const SOURCE_COLOR: Record<CalendarSource, string> = {
  essay: 'teal',
  'quarterly-report': 'cyan',
  'quarterly-scoring': 'grape',
  'perf-review': 'indigo',
  'review-360': 'orange',
  goal: 'pink',
};

export const sourceColor = (source: CalendarSource): string => SOURCE_COLOR[source] ?? 'gray';

/** Точка берёт насыщенный тон — он одинаков в обеих темах. */
export const sourceDot = (source: CalendarSource): string =>
  `var(--mantine-color-${sourceColor(source)}-filled)`;

/**
 * Фон и текст полосы — «светлый» вариант токена, а не фиксированный оттенок:
 * `-light` сам темнеет в тёмной теме, тогда как `-1` в ней светится.
 */
export const sourceSoftBg = (source: CalendarSource): string =>
  `var(--mantine-color-${sourceColor(source)}-light)`;

export const sourceSoftText = (source: CalendarSource): string =>
  `var(--mantine-color-${sourceColor(source)}-light-color)`;

export const CALENDAR_SOURCES = Object.keys(SOURCE_COLOR) as CalendarSource[];
